const MediaCategory = {
  PROPERTY: 'Properties',
  PROPERTY_TYPE: 'Property-Types',
  AMENITY: 'Amenities',
};

export default MediaCategory;
